import 'lodash';
import toastr from 'toastr';
import Collapse from 'bootstrap/js/dist/collapse.js';

$(function () {
    // Global variables
    let start_status = false;
    const fields_by_heating_type = $('#fields-by-heating-type');
    const wybierz_rodzaj_ogrzewania_input = $("input[name='wybierz_rodzaj_ogrzewania']");
    const resultsWithProposedProductsAndPdfButton = $('#results-with-proposed-products-and-pdf-button');
    let allRegulatorsSelected = false;

    function mainOperations() {
        // Sections
        const start = $('#start');
        const wybierz_rodzaj_ogrzewania = $('#wybierz-rodzaj-ogrzewania');

        // Start configurator
        $('#start-configurator').click(function () {
            start.fadeOut(500, function () {
                wybierz_rodzaj_ogrzewania.fadeIn();
            });
            start_status = true;
        });

        configuratorQuantityInput();
        maxOrMinValueForConfiguratorQuantity();
    }

    function chooseHeatingTypeLoading(status) {
        const configuratorHeatingTypeLoading = $('#wybierz-rodzaj-ogrzewania .configurator-loading');
        const configuratorHeatingTypeLoadingBlur = $('#wybierz-rodzaj-ogrzewania .configurator-loading-blur');

        if(status) {
            configuratorHeatingTypeLoading.css('display', 'flex');
            configuratorHeatingTypeLoadingBlur.css('display', 'block');
        } else {
            configuratorHeatingTypeLoading.css('display', 'none');
            configuratorHeatingTypeLoadingBlur.css('display', 'none');
        }
    }

    function configuratorQuantityInput()
    {
        $(document).on('click', '.configurator-quantity__minus-btn', function() {
            let input = $(this).closest('.configurator-quantity').find('input').filter(':visible:first'); // Znajdź odpowiadające pole input
            let currentValue = parseInt(input.val(), 10);
            if (currentValue > parseInt(input.attr('min'), 10)) {
                input.val(currentValue - 1).trigger('change');
            }
        });

        // Obsługa kliknięcia przycisku plus
        $(document).on('click', '.configurator-quantity__plus-btn', function() {
            let input = $(this).closest('.configurator-quantity').find('input').filter(':visible:first'); // Znajdź odpowiadające pole input
            let currentValue = parseInt(input.val(), 10);
            if (currentValue < parseInt(input.attr('max'), 10)) {
                input.val(currentValue + 1).trigger('change');
            }
        });
    }

    window.pushDataLayerUsingConfiguratorEvent = function () {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event : 'kliknal_przycisk_pokaz_wyniki_konfigurator'
        });
    }

    window.getPriceResult = function () {
        // const priceResultDiv = $('#podsumowanie-cenowe .price-result__price');
        const priceResultFloating = $('.floating-price');
        const productsToCalculatePriceResults = $('.product-to-price-result').filter(function () {
            const type = $(this).attr('type');
            if (type === 'hidden') return true;
            if ((type === 'checkbox' || type === 'radio') && this.checked) return true;
            return false;
        });
        let pln = 0;
        let eur = 0;

        productsToCalculatePriceResults.each(function() {
            const closestProductElement = $(this).closest('.product');
            const pricePln = parseFloat(closestProductElement.attr('data-price-pln')) || 0;
            const priceEur = parseFloat(closestProductElement.attr('data-price-eur')) || 0;
            const amount = closestProductElement.attr('data-amount');

            pln += pricePln * amount;
            eur += priceEur * amount;
        });
        pln = pln.toFixed(2);
        eur = eur.toFixed(2);

        // let priceString = '<span><span class="eur">' + eur + ' €</span> ' + '<span class="pln">('+ pln +' zł)</span></span>';

        // priceResultDiv.attr('data-eur', eur);
        // priceResultDiv.attr('data-pln', pln);
        // priceResultDiv.html(priceString);
        // priceResultFloating.html(priceString)

        highlightCustomAmount();
        updateRegulatorsState();

        if (Number(eur) === 0 && !priceResultFloating.hasClass('show-before')) {
            priceResultFloating.hide();
        } else {
            priceResultFloating.show();
        }
    }

    const debouncedPushCustomizedDataToDB = _.debounce(() => {
        pushCustomizedDataToDB();
    }, 500);

    $(document).on('change', '.product-to-price-result, .product', function () {
        const buttonToDownloadPdf = $('#pobierz-pdf .download-results-in-pdf');
        if (!buttonToDownloadPdf.is(':disabled')) {
            buttonToDownloadPdf.attr('disabled', true);
        }

        getPriceResult();
        debouncedPushCustomizedDataToDB();
    });

    function updateRegulatorsState() {
        // 1) Dla każdej sekcji regulatorów oblicz sumę i pokaż/ukryj jej .alert-warning
        const $sections = $('.regulator-section');
        let allSectionsSelected = true;

        $sections.each(function () {
            const $sec = $(this);
            const $allAmounts = $sec.find('.custom-amount__amount');
            const $customAmount = $sec.find('.custom-amount').first();
            const maxAmount = parseInt($customAmount.attr('data-custom-amount-max-number'), 10) || 0;

            let total = 0;
            $allAmounts.each(function () {
                total += parseInt($(this).text().replace('x', ''), 10) || 0;
            });

            const sectionSelected = (total === maxAmount);
            if (!sectionSelected) {
                allSectionsSelected = false;
            }
        });

        // 2) Ustaw globalną flagę tylko gdy WSZYSTKIE sekcje są "pełne"
        allRegulatorsSelected = allSectionsSelected;

        const alertWarning = $('.alert-warning');
        const allMessagesWithErrors = $('.group-message').filter('.custom-title--error');

        const alertErrorsElement = alertWarning.find('.alert-errors');
        let htmlContent = '';

        // Iterujemy po wszystkich elementach i tworzymy <p class="mb-0">
        allMessagesWithErrors.each(function() {
            const messageText = $(this).text().trim(); // pobieramy tekst
            htmlContent += `<p class="mb-0">${messageText}</p>`;
        });

        // Wstawiamy wszystkie elementy do alertErrorsElement
        alertErrorsElement.html(htmlContent);

        if (allRegulatorsSelected) {
            alertWarning.stop(true, true).fadeOut(200);
            alertErrorsElement.stop(true, true).fadeOut(200);
        } else {
            alertWarning.stop(true, true).fadeIn(200);
            alertErrorsElement.stop(true, true).fadeIn(200);
        }

        const floatingPrice = $('.floating-price');
        if (floatingPrice.length) {
            if (allRegulatorsSelected) {
                floatingPrice.removeClass('show-before');
            } else {
                floatingPrice.addClass('show-before');
            }
        }
    }

    function customAmount() {
        // pomocnicza funkcja -- jedna, wspólna dla plus / minus
        $(document).on('click', '.custom-amount__plus', function () {
            const $amount = $(this).siblings('.custom-amount__amount');
            const $customAmount = $amount.closest('.custom-amount');
            const maxAmount = parseInt($customAmount.attr('data-custom-amount-max-number'), 10);
            const $group = $(this).closest('.group__product-inside-group');
            const isRegulatorSection = $group.hasClass('regulator-section');

            let current = parseInt($amount.text().replace('x', ''), 10) || 0;

            if (current < maxAmount) {
                current++;
                $amount.text('x' + current);

                const closestProductElement = $(this).closest('.product');
                closestProductElement.attr('data-amount', current);

                // 🔹 DODANY BLOK — kontrola sumy regulatorów
                if (isRegulatorSection) {
                    const $allAmounts = $group.find('.custom-amount__amount');

                    // Oblicz sumę wszystkich regulatorów w sekcji
                    let total = 0;
                    $allAmounts.each(function () {
                        total += parseInt($(this).text().replace('x', ''), 10);
                    });

                    // Jeśli przekroczyliśmy maxAmount, pokaż alert
                    if (total > maxAmount) {
                        const $group = $(this).closest('.group');
                        const groupTitle = $group.find('.group__title').text().trim();

                        // Wyodrębnienie bazowego tytułu i numeru (np. "Pomieszczenie 2")
                        const [baseTitle, ...rest] = groupTitle.split(" ");
                        const groupNumber = rest.join(" ").trim();

                        // Mapowanie tytułów na poprawne formy po "w ..."
                        const groupLocative = {
                            "Rozdzielacz": "rozdzielaczu",
                            "Pomieszczenie": "pomieszczeniu",
                            "Pompa": "pompie",
                            // dodaj inne jeśli potrzebne
                        };

                        // Wybór poprawnej formy lub domyślna (miejscownik = „w ...” + -ie)
                        const titleInLocative = groupLocative[baseTitle] || (baseTitle.toLowerCase() + "ie");

                        // Budowanie pełnej frazy z numerem (jeśli jest)
                        const fullTitleInLocative = groupNumber
                            ? `${titleInLocative} ${groupNumber}`
                            : titleInLocative;

                        // Komunikat
                        toastr.warning(
                            `Aby umożliwić dodanie tego regulatora, należy odpowiednio zmniejszyć liczbę wybranych regulatorów w ${fullTitleInLocative}.`,
                            'Osiągnięto maksymalną ilość!'
                        );

                        // Zmiejszenie wartości!
                        let currentVal = parseInt($amount.text().replace('x', ''), 10);
                        currentVal--;
                        $amount.text('x' + currentVal);
                        $amount.closest('.product').attr('data-amount', currentVal);
                    }
                }

                // Wywołanie 'change' po aktualizacji
                $(this).closest('.product').trigger('change');
            }
        });

        $(document).on('click', '.custom-amount__minus', function () {
            const $amount = $(this).siblings('.custom-amount__amount');
            const $customAmount = $amount.closest('.custom-amount');
            const minAmount = parseInt($customAmount.attr('data-custom-amount-min-number'), 10);
            const $group = $(this).closest('.group__product-inside-group');
            // const isRegulatorSection = $group.hasClass('regulator-section');

            let current = parseInt($amount.text().replace('x', ''), 10) || 0;

            if (current > minAmount) {
                current--;
                $amount.text('x' + current);

                const closestProductElement = $(this).closest('.product');
                closestProductElement.attr('data-amount', current);
                closestProductElement.trigger('change');
            }
        });
    }
    customAmount();

    window.highlightCustomAmount = function () {
        $('.regulator-section').each(function () {
            const $section = $(this);
            const $customAmounts = $section.find('.custom-amount');
            const maxAmount = parseInt($customAmounts.first().attr('data-custom-amount-max-number'), 10);

            // Liczymy aktualną sumę regulatorów w tej sekcji
            let currentTotal = 0;
            $customAmounts.each(function () {
                const val = parseInt($(this).find('.custom-amount__amount').text().replace('x', ''), 10) || 0;
                currentTotal += val;
            });

            // Sprawdzamy, czy wszystkie regulatory w tej sekcji są wybrane
            const sectionFullySelected = (currentTotal === maxAmount);

            // Aktualizacja informacji "Suma regulatorów" i klasy error
            $customAmounts.each(function () {
                let missingElementsAmount = 0;
                missingElementsAmount = maxAmount - currentTotal;
                const $el = $(this);
                $el.css('--after-content-main', '"Suma regulatorów: ' + currentTotal + '/' + maxAmount + '"');

                const groupMessageElement = $el.closest('.group').find('.group-message');
                if (!sectionFullySelected || currentTotal > maxAmount) {
                    $el.addClass('error');
                    groupMessageElement.removeClass('custom-title--success');
                    groupMessageElement.addClass('custom-title--error');
                    groupMessageElement.attr('data-type', 'error');

                    // Komunikat + odmiana
                    let word;
                    const n = missingElementsAmount;

                    // Odmiana liczby
                    if (n === 1) {
                        word = "regulator";
                    } else if ((n % 10 >= 2 && n % 10 <= 4) && (n % 100 < 12 || n % 100 > 14)) {
                        word = "regulatory";
                    } else {
                        word = "regulatorów";
                    }

                    // Mapowanie tytułów do rodzaju
                    const groupGender = {
                        "Rozdzielacz": "m",   // męski
                        "Pomieszczenie": "n", // nijaki
                        "Pompa": "f",         // żeński
                        // dodaj inne grupy
                    };

                    // Pobranie tytułu grupy
                    const groupTitle = $el.closest('.group').find('.group__title').text().trim();

                    // Wyodrębnienie podstawowego słowa (np. "Pomieszczenie" z "Pomieszczenie 2")
                    const baseTitle = groupTitle.split(" ")[0];
                    const gender = groupGender[baseTitle] || "m"; // domyślnie męski

                    // Wybór odpowiedniego słowa „działał/działała/działało”
                    let verb;
                    switch (gender) {
                        case "m":
                            verb = "działał";
                            break;
                        case "f":
                            verb = "działała";
                            break;
                        case "n":
                            verb = "działało";
                            break;
                    }

                    // Generowanie komunikatu
                    $el.closest('.group').find('.custom-title').text(
                        `Musisz dobrać jeszcze ${n} ${word}, aby ${groupTitle.toLowerCase()} ${verb} prawidłowo.`
                    );

                } else {
                    $el.removeClass('error');
                    groupMessageElement.attr('data-type', 'success');
                    groupMessageElement.removeClass('custom-title--error');
                    groupMessageElement.addClass('custom-title--success');
                    groupMessageElement.text('Wybrałeś wymaganą liczbę regulatorów.');
                }
            });
        });
    };

    window.pushCustomizedDataToDB = function () {
        const buttonToDownloadPdf = $('#pobierz-pdf .download-results-in-pdf');
        const productsArray = {};
        const groupsArray = {};

        $('.group').each(function () {
            // Group message
            const groupPath = $(this).attr('data-group-path');
            let groupMessage;
            let groupMessageType;
            if ($(this).find('.group-message')) {
                const groupMessageElement = $(this).find('.group-message');
                groupMessage = groupMessageElement.text();
                groupMessageType = groupMessageElement.attr('data-type');
            }

            if (groupPath) {
                groupsArray[groupPath] = {
                    'group-message': groupMessage,
                    'group-message-type': groupMessageType,
                }
            }
        })

        $('.product').each(function() {
            const pathInResult = $(this).attr('data-path-in-result');
            const amount = $(this).attr('data-amount');

            const productToPriceResultField = $(this).find('.product-to-price-result');
            const productToPriceResultFieldType = productToPriceResultField.attr('type');
            let markedByUser = false;
            let requiredProduct = false;

            if ((productToPriceResultFieldType === 'checkbox' || productToPriceResultFieldType === 'radio') && productToPriceResultField.is(':checked')) {
                markedByUser = true;
            } else if (productToPriceResultField.attr('type') === 'hidden' && $(this).closest('.group__product-inside-group').hasClass('regulator-section')) {
                // wyjątek dla regulatorów
                if ($(this).attr('data-amount') > 0) {
                    markedByUser = true;
                }
                requiredProduct = false;
            } else if (productToPriceResultField.attr('type') === 'hidden') {
                requiredProduct = true;
            }

            // Amount error
            let amountError;
            if ($(this).find('.custom-amount').hasClass('error')) {
                amountError = $(this).find('.custom-amount')[0]
                    .style.getPropertyValue('--after-content-main')
                    .replace(/^["']|["']$/g, ''); // usuwa " lub ' z początku i końca
            }

            if (pathInResult) {
                productsArray[pathInResult] = {
                    'custom-amount': amount,
                    'marked-by-user': markedByUser,
                    'required-product': requiredProduct,
                    'amount-error': amountError
                };
            }
        });

        const priceResultPrice = $('.price-result__price');
        const finalPriceEur = priceResultPrice.attr('data-eur');
        const finalPricePln = priceResultPrice.attr('data-pln');

        // Teraz produkty są w tablicy productsArray i można je wysłać za pomocą Ajax
        $.ajax({
            url: '/proxy/konfigurator-produktow-salus-zapisz-dane/' + $('#pobierz-pdf .download-results-in-pdf').data('id'),
            method: 'POST',
            data: {
                products: productsArray,
                groups: groupsArray,
                finalPriceEur: finalPriceEur,
                finalPricePln: finalPricePln,
                isComplete: allRegulatorsSelected,
            },
            success: function(response) {
                buttonToDownloadPdf.attr('disabled', false);
            },
            error: function(error) {
                console.log('Wystąpił błąd podczas synchronizacji danych.', error);
                alert('Wystąpił błąd podczas synchronizacji danych.');
            }
        });
    }

    function generateAndDownloadPdf()
    {
        $(document).on('click', '#pobierz-pdf .download-results-in-pdf', function () {
            const button = $(this);
            const downloadUrl = button.attr('data-download-url');
            const downloadName = button.attr('data-download-name');
            button.prop("disabled", true);
            button.text('Generowanie PDF');
            button.addClass('loading');

            fetch(downloadUrl)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Nie udało się pobrać pliku');
                    }
                    return response.blob(); // Pobieramy dane jako Blob (dane binarne)
                })
                .then(blob => {
                    const a = document.createElement('a');
                    const url = URL.createObjectURL(blob); // Tworzymy URL dla Blob
                    a.href = url;
                    a.download = downloadName; // Ustawiamy nazwę pliku
                    document.body.appendChild(a);
                    a.click(); // Symulujemy kliknięcie, by pobrać plik
                    a.remove(); // Usuwamy element po użyciu
                    URL.revokeObjectURL(url); // Zwolnienie URL
                    button.text('PDF został pobrany!');
                    button.removeClass('loading');
                    setTimeout(function() {
                        button.text('Pobierz konfigurację w .PDF');
                        button.prop("disabled", false);
                    }, 4000);
                })
                .catch(error => {
                    alert('Wystąpił błąd pobierania.')
                    button.prop("disabled", false);
                });
        });
    }
    generateAndDownloadPdf();

    function maxOrMinValueForConfiguratorQuantity()
    {
        $(document).on('input', '.configurator-quantity input', function() {
            const input = $(this); // jQuery obiekt
            const min = parseInt(input.attr('min'));
            const max = parseInt(input.attr('max'));
            const value = parseInt(input.val());

            if (value > max) {
                input.val(max); // Jeśli wartość większa niż max, ustawiamy na max.
            } else if (value < min) {
                input.val(min); // Jeśli wartość mniejsza niż min, ustawiamy na min.
            }
        });
    }

    // Execute main function
    mainOperations();

    // Przełączanie głównych kategorii i ładowanie formularzy
    wybierz_rodzaj_ogrzewania_input.change(function () {
        $('.salus-controls-product-configurator').off();

        const heatingTypeValue = wybierz_rodzaj_ogrzewania_input.filter(':checked').val();

        chooseHeatingTypeLoading(true);
        fields_by_heating_type.html('');
        resultsWithProposedProductsAndPdfButton.fadeOut();
        resultsWithProposedProductsAndPdfButton.html('');
        $('#contact-with-us').fadeOut();

        $.ajax({
            url: '/proxy/configurator-load-fields-by-heating-type-ajax',
            type: 'POST',
            data: {
                heating_type: heatingTypeValue
            },
            success: function(response) {
                const responseView = response.view;
                fields_by_heating_type.html(responseView);
                // heatingLoopsMinMax();

                chooseHeatingTypeLoading(false);
            },
            error: function(response) {
                alert('Wystąpił błąd. Spróbuj ponownie później.');
                chooseHeatingTypeLoading(false);
            }
        });
    });

    // Toggle class "więcej produktów"
    $(document).on('click', '.more-products-button', function() {
        $(this)
            .toggleClass("more-products-button--active")
            .text($(this).text() === 'Sprawdź alternatywy' ? 'Ukryj alternatywy' : 'Sprawdź alternatywy');
    });


    function isInViewport(element) {
        const $el = $(element);
        if ($el.length === 0) {
            // Element nie istnieje jeszcze w DOM
            return false;
        }

        const elementTop = $el.offset().top;
        const elementBottom = elementTop + $el.outerHeight();
        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    function isBelowElement(selector) {
        const $el = $(selector);
        if ($el.length === 0) return false;

        const elementBottom = $el.offset().top + $el.outerHeight();
        const viewportTop = $(window).scrollTop();

        // Jeśli górna część viewportu jest poniżej elementu → jesteśmy pod nim
        return viewportTop > elementBottom;
    }

    // $(window).on('scroll resize', function() {
    //     if (
    //         isInViewport('#podsumowanie-cenowe') ||
    //         isBelowElement('#podsumowanie-cenowe')
    //     ) {
    //         $('.floating-price').stop(true, true).fadeOut();
    //     } else {
    //         $('.floating-price').stop(true, true).fadeIn();
    //     }
    // });
    //
    // // Opcjonalnie: nasłuchiwanie na dynamiczne pojawienie się elementu
    // const observer = new MutationObserver(function() {
    //     if ($('#podsumowanie-cenowe').length) {
    //         $(window).trigger('scroll'); // wymusza sprawdzenie widoczności
    //     }
    // });
    //
    // observer.observe(document.body, { childList: true, subtree: true });
});
